import type { SupTransactionType } from "@/types";
import { SupText } from "@repo/core-ui";
import dictionaryConfig from "@/../config/dictionary.config";
import { SupLinkExternal } from "@repo/core-ui";
import Link from "next/link";
import React from "react";

interface Web3CommonVaultMultiStepProps {
  type?: SupTransactionType;
}

const DICTIONARY: Record<SupTransactionType, string> = {
  deposit: "This vault has multiple steps required for withdrawal. You will receive vault shares when you withdraw.",
  withdraw: "After you withdraw from Superform you will need to complete the withdrawal on the protocol's site.",
};

export default function Web3CommonVaultMultiStep({ type = "deposit" }: Web3CommonVaultMultiStepProps) {
  return (
    <div className="space-y-2 p-2">
      <SupText variant="caption" weight="bold">
        Multi-Step Vault
      </SupText>
      <SupText variant="subtitle2" className="normal-case">
        {DICTIONARY[type]}
      </SupText>
      {type !== "withdraw" && (
        <Link href={dictionaryConfig.retain4626.helpArticle} className="group flex items-center space-x-2 text-neutral-500" target="_blank">
          <SupText variant="caption" className="flex underline group-hover:no-underline">
            Learn More
          </SupText>
          <SupLinkExternal />
        </Link>
      )}
    </div>
  );
}
